import React, {useState} from "react";
import {useSelector} from "react-redux";
import {useSearchParams} from "react-router-dom";
import {Button} from "primereact/button";
import {TabPanel, TabView} from "primereact/tabview";
import PageHeaderButton from "../components/page-header-button";
import AdminAccessDenied from "../../system/components/admin-access-denied";
import {ADMIN_PERMISSIONS, hasAdminPermission} from "../../system/admin-access";
import ContentEditorDialog from "./content-editor-dialog";
import ContentsTab from "./contents-tab";
import {useHelpCms} from "./help-cms";
import OverviewTab from "./overview-tab";
import RelationsTab from "./relations-tab";
import SearchNeedsTab from "./search-needs-tab";
import SettingsTab from "./settings-tab";
import TaxonomyTab from "./taxonomy-tab";

const TABS = [
    {key: "overview", label: "نمای کلی"},
    {key: "contents", label: "محتواها"},
    {key: "taxonomy", label: "دسته‌ها و برچسب‌ها"},
    {key: "relations", label: "ارتباط محتواها"},
    {key: "search", label: "نیازهای بدون پاسخ"},
    {key: "settings", label: "تنظیمات نمایش"},
];

// "مدیریت محتوی": the support team writes the articles/videos shown on the public /help page.
function ContentManagement() {
    const {user} = useSelector((state) => state.auth);
    const [searchParams, setSearchParams] = useSearchParams();
    const data = useHelpCms();
    const [filter, setFilter] = useState({});
    const [editor, setEditor] = useState({visible: false, item: null, title: ""});
    const requested = TABS.findIndex((tab) => tab.key === searchParams.get("tab"));
    const [activeIndex, setActiveIndex] = useState(requested >= 0 ? requested : 0);

    if (!hasAdminPermission(user, ADMIN_PERMISSIONS.CONTENT_MANAGEMENT_VIEW)) return <AdminAccessDenied/>;

    const openTab = (key, nextFilter) => {
        const index = TABS.findIndex((tab) => tab.key === key);
        if (index < 0) return;
        if (key === "contents") setFilter(nextFilter || {});
        setActiveIndex(index);
        setSearchParams({tab: key});
    };
    const openEditor = (item = null, title = "") => setEditor({visible: true, item, title});
    const tabProps = {
        data,
        reload: data.reload,
        openTab,
        onNew: (title) => openEditor(null, typeof title === "string" ? title : ""),
        onEdit: (item) => openEditor(item),
    };

    return (
        <div className="w-full p-3 flex flex-column gap-3 rtl text-xs">
            <PageHeaderButton
                title="content-management"
                description="content-management-description"
                end={<Button icon="pi pi-refresh" label="به روزرسانی" className="p-button-sm p-button-outlined gap-2" loading={data.loading} onClick={data.reload}/>}
            />
            {data.error && <div className="text-red-500 text-sm px-3">بارگذاری اطلاعات محتوا انجام نشد.</div>}
            <TabView
                activeIndex={activeIndex}
                onTabChange={(event) => openTab(TABS[event.index].key)}
                className="rtl text-xs"
                pt={{nav: {className: "rtl flex-nowrap"}, panelContainer: {className: "p-3 border-1 border-200 border-round-bottom-xl"}}}
            >
                {TABS.map((tab, index) => (
                    <TabPanel key={tab.key} header={tab.label} pt={{headerAction: {className: "text-xs white-space-nowrap"}}}>
                        {activeIndex === index && (
                            tab.key === "overview" ? <OverviewTab {...tabProps}/>
                                : tab.key === "contents" ? <ContentsTab {...tabProps} filter={filter} setFilter={setFilter}/>
                                    : tab.key === "taxonomy" ? <TaxonomyTab {...tabProps}/>
                                        : tab.key === "relations" ? <RelationsTab {...tabProps}/>
                                            : tab.key === "search" ? <SearchNeedsTab {...tabProps}/>
                                                : <SettingsTab {...tabProps}/>
                        )}
                    </TabPanel>
                ))}
            </TabView>
            <ContentEditorDialog
                visible={editor.visible}
                item={editor.item}
                prefillTitle={editor.title}
                data={data}
                onHide={() => setEditor((current) => ({...current, visible: false}))}
                onSaved={data.reload}
            />
        </div>
    );
}

export default ContentManagement;
